import {observable} from 'mobx';

import {DomUtils} from "../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../bootstrap/models/site-config";
import {DeviceStore} from "../app/device.store";
import {SESSION_STORAGE_KEYS} from "../consts";
import {BaseManager} from "../../infrastructure/managers/base-manager";
import {SessionStorageUtils} from "../../infrastructure/utils/session-storage.utils";

import {singleton} from "../../infrastructure/decorators/singleton";

@singleton
export class ImpressionCounterManager extends BaseManager {
  @observable impressions: Object<Object>;
  sessionStorageUtils: SessionStorageUtils;

  static injectables = [...BaseManager.injectables, SessionStorageUtils];

  constructor(domUtils: DomUtils, logger: LoggerUtils, siteConfig: SiteConfig, deviceStore: DeviceStore, sessionStorageUtils: SessionStorageUtils) {
    super(domUtils, logger, siteConfig, deviceStore);

    this.sessionStorageUtils = sessionStorageUtils;
    this.impressionKey = SESSION_STORAGE_KEYS.impressionCount;

    this.initialize();
  }

  initialize() {
    this.impressions = this._getImpression();

    if (this.impressions === undefined) {
      this.impressions = {};
      this._setImpression()
    }
  }

  _setImpression() {
    this.sessionStorageUtils.set(this.impressionKey, this.impressions);
  }

  _getImpression() {
    return this.sessionStorageUtils.get(this.impressionKey)
  }

  set(key: String, count: Number) {
    this.impressions[key] = count
    this._setImpression();
  }

  get(key: String) {
    const impression: Number = this.sessionStorageUtils.get(this.impressionKey)

    return impression[key]
  }

  increment(key: String) {
    if (this.impressions[key] === undefined) {
      this.impressions[key] = 0
    } else {
      this.impressions[key]++;
    }

    this._setImpression();
  }

  clear() {
    this.sessionStorageUtils.delete(this.impressionKey)
  }
}